export const enum MaxLengths {
    PHONE_NUMBER = 9, 
    TRANSPORT_UNIT_NUMBER = 11
}